import {motion as m} from 'framer-motion';
import ScrollToTop from '../../components/ScrollToTop';
import {useEffect} from 'react';
import PageHeaderImage from '../../images/pageheader.jpg';
import PageHeader from '../../components/PageHeader';
import {Link} from 'react-router-dom';
import SafeImage from '../../images//homepage-header/Vallan-pest-control.png';
import WhyUs from '../../components/WhyUs';
import ContactCta from '../../components/ContactCta';
import FAQS from '../../components/FAQS';
import './consultancyTraining.css';

const ConsultancyTraining = () => {
    return (
        <m.div 
            initial={{x: "-100%"}}
            animate={{x: "-0%"}}
            transition={{ duration: 0.9, delay:0.7}}
            exit={{opacity: 1}}
        >
            <ScrollToTop />
            <PageHeader title="Consultancy & Training" image={PageHeaderImage}>
                <p>
                    <Link to="/">Home</Link> / <Link to="/services">Services</Link> / Consultancy & Training
                </p>
            </PageHeader>
            <section className='services'>

                <div className="consultancy-training-services">
                    <div className="container consultancy-training-content-container">
                        <div className="consultancy-training-content">
                            <h1>
                                Consultancy and Training
                            </h1>
                            <br />
                            <p>
                                As a pest control company in Kenya, PestEX Masters understands that pest infestations can be a major
                                problem for both residential and commercial properties. We also understand that the key to effective
                                pest control is prevention. That&#39;s why we offer comprehensive consultancy and training services to help
                                our clients prevent pest infestations before they occur.
                            </p>
                            <p>
                                Our consultancy services are designed to identify potential pest problems before they become major
                                issues. We conduct thorough inspections of your property, identifying areas where pests are likely to
                                enter and thrive. We also provide recommendations for pest prevention, such as sealing entry points,
                                removing food sources, and implementing appropriate sanitation practices.
                            </p>
                            <p>
                                Our training services are designed to educate property owners and managers on how to prevent and
                                control pest infestations. We offer customized training programs tailored to your specific needs,
                                whether you&#39;re a homeowner or a commercial property owner. Our expert trainers will teach you and
                                your staff how to identify and prevent pest infestations, as well as how to safely and effectively use pest
                                control products.
                            </p>
                            <p>
                                At PestEX Masters, we believe that prevention is the key to effective pest control. By taking a proactive
                                approach to pest control through our consultancy and training services, we help our clients avoid the
                                cost and hassle of dealing with a major pest infestation. Contact us today to learn more about our
                                consultancy and training services, and how we can help you keep your property pest-free.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="container consultancy-training-saftey-cont">
                    <div className='saftey'>
                        <div className="container saftey_container">
                            <div className="saftey_header">
                                <h1>We use safe and environmentally friendly measures.</h1>
                                <p>Want to create a pest-free environment without compromising your commitment to sustainability? Our environmentally friendly pest control products are the solution.</p>
                            </div>
                            <div className="saftery_image">
                                <img src={SafeImage} alt="" />
                            </div>
                        </div>
                    </div>
                    {/* <HomeServices /> */}
                    <WhyUs />
                    <ContactCta />
                    <FAQS />
                </div>
            </section>
        </m.div>
    )
}

export default ConsultancyTraining